import { useIntersection } from "@mantine/hooks";
import { PropsWithChildren } from "react";

import { SearchWithPagination } from "./SearchWithPagination";

type Props = {
  onSearchChange: (value: string) => void;
  searchValue: string;
  autofocus?: boolean;
  className?: string;
  top?: number;
} & (
  | {
      itemCount: number | undefined;
      pageSize: number;
      page: number;
      onPageChange: (page: number) => void;
      hidePagination?: false;
    }
  | {
      itemCount?: undefined;
      pageSize?: undefined;
      page?: undefined;
      onPageChange?: undefined;
      hidePagination: true;
    }
) &
  PropsWithChildren;

export const SearchWithPaginationSticky: React.FC<Props> = ({ top = 16, ...props }) => {
  const { ref, entry } = useIntersection({
    threshold: 1,
    rootMargin: `-${top}px 0px 0px 0px`,
  });

  const isSticky = entry?.isIntersecting === false;

  return (
    <>
      <div ref={ref} css={{ visibility: isSticky ? "hidden" : "visible" }}>
        <SearchWithPagination {...props} />
      </div>
      {isSticky && <SearchWithPagination {...props} isSticky top={top} />}
    </>
  );
};
